import React from "react";
import { Box, Link } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

export const VideoItemNode = (props) => {
  let seconds = props.duration;
  let durationMessage = "";

  if (seconds && seconds > 0) {
    let hours = 0;
    let minutes = 0;

    hours = Math.floor(seconds / 3600);
    seconds = seconds - hours * 3600;

    minutes = Math.floor(seconds / 60);
    seconds = seconds - minutes * 60;

    durationMessage =
      "(" +
      (hours > 0 ? (hours < 10 ? "0" + hours + ":" : hours + ":") : "") +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds) +
      ")";
  }

  return (
    <Box>
      <Link href={props.location} isExternal={true} color="teal.500">
        {props.description} <ExternalLinkIcon />
      </Link>{" "}
      {durationMessage}
    </Box>
  );
};
